import { ReactElement } from "react"

import { OfferedService, Psychologist } from "utils/interfaces"
import { IS_DEVELOPMENT } from "utils/env-management"
import { capitalize } from "utils/utils"
import { numberToYearsInRussian } from "utils/infrastructure/wording-utils"

export function psychologistTitles(psy: Psychologist) {
    return psy.titles && psy.titles.length ? psy.titles : ["психолог"]
}

export function formatExperience(experience: number) {
    return experience < 1 ? "до 1 года" : `${experience} ${numberToYearsInRussian(experience)}`
}

export function formatTitlesShort(titles: string[] | undefined) {
    return titles && titles.length ? titles.map((t) => capitalize(t))[0] : ["Психолог"]
}

export function getPublicServices(services: OfferedService[]) {
    return services.filter((service) => service.public)
}

export function getNotSupervision(services: OfferedService[]) {
    return services.filter((service) => service.service_type_id !== 24)
}

export function getFamilyServices(services: OfferedService[]) {
    return services.filter((service) => service.family)
}

export function getAvailableServices(services: OfferedService[]) {
    return services.filter((service) => service.available)
}

export function getLowestServicePrice(services: OfferedService[]) {
    const prices = services?.map((s) => s.price) ?? []

    return prices.length > 0 ? Math.min(...prices) : undefined
}

export function onlineSessionAvailable(psy: Psychologist) {
    return Boolean(psy.offered_services.find((service) => service.online))
}

//\xa0 is a non-breaking space represented in a javascript, it fixes breaking after "м.", "ул.", "пос." for example "м. Новокузнецкая"
export function renderCityWithDetails(
    city: string,
    city_details?: string,
    location?: string,
    cityDetailDivider?: ReactElement
) {
    return (
        <span>
            {city}
            {location && <span>, {location}</span>}
            {city_details && (
                <span>
                    {cityDetailDivider !== null && city ? "," : ""}
                    <> {city_details.replace(/\./g, ".\xa0")}</>
                </span>
            )}
        </span>
    )
}

export function getFaceUrl(
    faceUrl: string,
    psyHashId: string = Math.floor(Math.random() * 10).toString()
) {
    if (IS_DEVELOPMENT) {
        const index = parseInt(psyHashId?.match(/\d/)?.[0] ?? "1", 10)
        return `/devfaces/psy${(index % 5) + 1}.jpg`
    }
    return faceUrl
}
